export const NotificationSettings = {
  NoEmail: _TL_('No email'),
  OnlyFailures: _TL_('Only if there are failures'),
  EveryImport: _TL_('Every time there is an import'),
};
